import cxs from 'cxs';
import { FLATTENED_COLOURS } from '../../../common/styles/vars';















const ICON_COLOUR = (
{ color, requiresStroke }) => (
{
  fill: FLATTENED_COLOURS[color],
  stroke: requiresStroke ? FLATTENED_COLOURS[color] : void 0
});

function getColourStyles({ color, requiresStroke }) {
  const COLOUR = ICON_COLOUR({ color, requiresStroke });

  return { ' path': COLOUR, ' rect': COLOUR, ' polygon': COLOUR };
}

export const ICON_CONTAINER = (
{ size, hoverColor, ignoresColour, requiresStroke }) =>
cxs({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: `${size}px`,
  minWidth: `${size}px`,

  ...(hoverColor && !ignoresColour ?
  {
    ':hover': {
      ' > *:first-child': {
        ...getColourStyles({ color: hoverColor, requiresStroke })
      }
    }
  } :
  {}),


  ' div': {
    display: 'inline-flex',
    alignItems: 'center'
  }
});

export const ICON_SVG = ({ color, requiresStroke, ignoresColour, size }) => {
  const sizePx = { height: `${size}px`, width: `${size}px` };
  const svgContainerStyle = {
    ...sizePx,

    ' > svg': {
      ...sizePx,
      display: 'flex'
    }
  };

  if (ignoresColour) {return cxs(svgContainerStyle);}

  return cxs({ ...getColourStyles({ color, requiresStroke }), ...svgContainerStyle });
};

export const CLICKABLE = cxs({ cursor: 'pointer' });